<template>
<div>
    <div class="bg-gradient"></div>
    <div class="main-page">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="search-holder mt-30 search-holder-list">
                        <div class="input-group">
                            <!-- <input type="text" class="form-control rounded-right" placeholder="Search Enquiry" /> -->
                            <input type="text" placeholder="Search by broker name" @input="(e) => (Filter = e.target.value)" :value="Filter" class="search form-control" @keyup.enter="FilterData" />
                            <svg v-if="Filter" @click="resetFilter" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512.001 512.001" style="enable-background: new 0 0 512.001 512.001" xml:space="preserve" width="14" height="14" class="close r-70">
                                <g>
                                    <g>
                                        <path d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                              L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                              c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                              l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                              L284.286,256.002z" />
                                    </g>
                                </g>
                            </svg>
                            <svg
                  v-if="Filter"
                  @click="resetFilter"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 512.001 512.001"
                  style="enable-background: new 0 0 512.001 512.001"
                  xml:space="preserve"
                  width="14"
                  height="14"
                  class="close"
                >
                  <g>
                    <g>
                      <path
                        d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717
                            L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859
                            c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287
                            l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285
                            L284.286,256.002z"
                      />
                    </g>
                  </g>
                </svg>
                            <div class="input-group-append align-fix" id="button-addon4">
                                <!-- <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">Go</button> -->
                                <button class="btn btn-white rounded-right" :disabled="!Filter" @click="FilterData" type="button">
                                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 451 451" style="enable-background: new 0 0 451 451" xml:space="preserve">
                                        <g>
                                            <path d="M447.05,428l-109.6-109.6c29.4-33.8,47.2-77.9,47.2-126.1C384.65,86.2,298.35,0,192.35,0C86.25,0,0.05,86.3,0.05,192.3
                                          s86.3,192.3,192.3,192.3c48.2,0,92.3-17.8,126.1-47.2L428.05,447c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4
                                          C452.25,441.8,452.25,433.2,447.05,428z M26.95,192.3c0-91.2,74.2-165.3,165.3-165.3c91.2,0,165.3,74.2,165.3,165.3
                                          s-74.1,165.4-165.3,165.4C101.15,357.7,26.95,283.5,26.95,192.3z" />
                                        </g>
                                    </svg>
                                </button>
                                <button v-b-toggle.sidebar-right class="filter-menu btn btn-filter btn-white" type="button">
                                    <img src="@/assets/filter.svg" alt="" />
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <span class="result-Text">{{ pageStart }} - {{ pageEnd }} of {{ total }}</span>
                        </div>
                    </div>
                </div>
                <!-- Enquiry Card -->
                <div class="col-12">
                    <div class="card enquiry-card m-height">
                        <b-list-group class="list-group-flush">
                            <b-list-group-item v-for="item in GetAllCpMeetings" :key="item.id">
                                <div class="row">
                                    <div class="col-6 pr-1" @click="goToMeetingDetails(item)">
                                        <span class="name ellipses" v-if="item.broker_name">{{item.broker_name}}</span>
                                        <span class="project-name" v-if="item.created_at">{{`${item.created_at}`}}</span>
                                    </div>
                                    <div class="col-6 pl-1 text-right">
                                        <span class="label label-tag" v-if="item.assigned_to">{{item.assigned_to}}</span>
                                        <!-- <b-button v-b-modal.modal-1 @click="deleteRecord($event, item)">Delete</b-button> -->
                                    </div>

                                </div>
                            </b-list-group-item>
                        </b-list-group>
                    </div>
                </div>
            </div>
            <div class="pagination-holder">
                <paginate v-if="totalPages > 1" v-model="pageNo" :page-count="totalPages" :click-handler="goToPage" :page-class="'page-item'" :page-link-class="'page-link'" :prev-link-class="'page-link'" :next-link-class="'page-link'" :disabled-class="'page-item disabled'" :container-class="'pagination justify-content-center'">
                </paginate>
            </div>
            <b-sidebar id="sidebar-right" ref="sidebar-right" title="Advance Search" bg-variant="white" backdrop right shadow>
                <template v-slot="{ hide }">
                    <div class="card form-card sidebar-form-card">
                        <b-form @submit.prevent="AdvancedFilter" @reset="resetAdvancedFilter">
                            <b-form-group label="Created At From">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.created_at_from" placeholder="Created At From"></datetime>
                            </b-form-group>
                            <b-form-group label="Created At Upto">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.created_at_upto" placeholder="Created At Upto"></datetime>
                            </b-form-group>
                            <b-form-group label="Meeting Scheduled From">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.meeting_scheduled_from" placeholder="Meeting Scheduled From"></datetime>
                            </b-form-group>
                            <b-form-group label="Meeting Scheduled Upto">
                                <datetime type="datetime" v-model="AdvancedFilterMeeting.meeting_scheduled_upto" placeholder="Meeting Scheduled Upto"></datetime>
                            </b-form-group>
                            <b-form-group label="Cp Name">
                                <b-form-input class="form-multiselect" v-model="AdvancedFilterMeeting.name" placeholder="Cp Name"></b-form-input>
                            </b-form-group>
                            <b-form-group label="Firm Name">
                                <b-form-input class="form-multiselect" v-model="AdvancedFilterMeeting.firm_name" placeholder="Firm Name"></b-form-input>
                            </b-form-group>
                            <b-form-group label="">
                              <label>Ticket status</label>
                              <b-form-select v-model="AdvancedFilterMeeting.ticket_status">
                                  <b-form-select-option :value="null" selected disabled>Select One</b-form-select-option>
                                  <b-form-select-option value='Open'>Open</b-form-select-option>
                                  <b-form-select-option value='Closed'>Closed</b-form-select-option>
                                  <b-form-select-option value='Lapsed'>Lapsed</b-form-select-option>
                              </b-form-select>
                            </b-form-group>
                            <b-form-group label="Field Executives">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.meeting_executive_ids" :searchable="true" placeholder="Field Executives" label="full_name" track-by="id" :options="userIdSettings" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Building">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.building_ids" :searchable="true" placeholder="Project Name" label="name" track-by="id" :options="projects" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Request id">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.request_uuids" :searchable="true" placeholder="Request id" label="request_uuid" track-by="id" :options="cp_requests_uuids" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>
                            <b-form-group label="Broker uuid">
                                <multiselect class="form-multiselect" v-model="AdvancedFilterMeeting.broker_uuids" :searchable="true" placeholder="Broker uuid" label="uuid" track-by="id" :options="brokers_uuids" :multiple="true" :taggable="false"></multiselect>
                            </b-form-group>

                            <b-form-group class="btn-fixed">
                                <b-button variant="primary" type="submit" block @click="hide">Search</b-button>
                                <b-button variant="primary-outline" block type="reset">Reset</b-button>
                            </b-form-group>
                        </b-form>
                    </div>
                </template>
            </b-sidebar>

            <!-- Modal -->
            <div>
                <b-modal ref="my-modal" id="modal-1" hide-footer>
                    <p class="my-4">Are you sure you want to delete</p>
                    <div class="text-right">
                        <button class="btn btn-success" @click="$refs['my-modal'].hide()">Cancel</button>
                        <button class="btn btn-danger ml-3" @click="deleteRecordFromModal">Delete</button>
                    </div>
                </b-modal>
            </div>
        </div>
    </div>
</div>
</template>

  
<script>
import {
    paramsFromQuery,
    decodeMyCpMeetingSearchParams
} from "@/assets/scripts/utility.js";
import {
    Datetime
} from 'vue-datetime';
import Multiselect from 'vue-multiselect';
import qs from "qs";
import router from "../router";

export default {
    name: "MyCpMeeting",
    components: {
        datetime: Datetime,
        Multiselect
    },
    data() {
        return {
            GetAllCpMeetings: [],
            Filter: this.$route.query.search_query,
            total: 0,
            perPage: 0,
            allSettings: [],
            userIdSettings: [],
            projects: [],
            cp_requests_uuids: [],
            brokers_uuids: [],
            index: 0,
            selectedItem: null,
            AdvancedFilterMeeting: {
                created_at_from: null,
                created_at_upto: null,
                meeting_scheduled_from: null,
                meeting_scheduled_upto: null,
                name: "",
                firm_name: "",
                ticket_status: null,
                meeting_executive_ids: [],
                building_ids: [],
                request_uuids: [],
                broker_uuids: [],

            }
        }
    },
    created() {
        sessionStorage.setItem("isFromMyCpMeeting", true);
        this.getMeetingTypesList();
        this.FetchAllMyCpMeetings();
    },
    watch: {
        $route(to, from) {
            this.FetchAllMyCpMeetings();
        },
    },
    methods: {
        deleteRecord(event, item) {
            this.index = this.GetAllCpMeetings.indexOf(item);
            this.selectedItem = item;
        },
        deleteRecordFromModal(){
            this.$axios.delete(`/cp_meeting_requests/${this.selectedItem.id}`, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    this.GetAllCpMeetings.splice(this.index, 1);
                    this.FetchAllMyCpMeetings();
                    this.$refs['my-modal'].hide()
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        goToMeetingDetails(item) {
            router.push({
                name: 'MyCpMeetingDetails',
                params: {
                    id: item.id
                }
            });
        },
        FetchAllMyCpMeetings() {
            let queryP = {}
            let advSearchParams;
            paramsFromQuery(queryP, this.$route.query);
            if (this.$route.query.is_advanced_search) {
                let searchParams = this.$route.query
                for (let key in searchParams) {
                    queryP[key] = searchParams[key];
                }
                advSearchParams = queryP
            }
            if (advSearchParams) {
                paramsFromQuery(queryP, advSearchParams);
            } else {
                paramsFromQuery(queryP, this.$route.query);
            }
            this.$axios.get(`/cp_meeting_requests`, {
                params: queryP,
                paramsSerializer: (params) =>
                    qs.stringify(params, {
                        arrayFormat: "brackets"
                    }),
            }).then((res) => {
                console.log(res.data)
                this.GetAllCpMeetings = res.data.cp_meetings;
                this.perPage = res.data.per_page;
                this.total = res.data.total_count;
            }).catch((err) => {
                console.log(err);
            });
        },
        getMeetingTypesList() {
            this.$axios.get("/cp_meeting_requests/settings", {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((res) => {
                    this.allSettings = res.data;
                    this.userIdSettings = this.allSettings.field_executives;
                    this.projects = this.allSettings.projects;
                    this.cp_requests_uuids = this.allSettings.cp_requests_uuids;
                    this.brokers_uuids = this.allSettings.brokers_uuids;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        AdvancedFilter() {
            const sendData = decodeMyCpMeetingSearchParams(this.AdvancedFilterMeeting);
            let newQ = {
                ...sendData,
                is_advanced_search: true
            };
            this.$router.replace({
                query: newQ
            });
        },
        resetAdvancedFilter() {
            this.AdvancedFilterMeeting = {
                created_at_from: null,
                created_at_upto: null,
                meeting_scheduled_from: null,
                meeting_scheduled_upto: null,
                name: '',
                firm_name: '',
                ticket_status: null,
                meeting_executive_ids: [],
                building_ids: [],
                request_uuids: [],
                broker_uuids: []
            };
            let rQ = this.$route.query
            if (rQ.is_advanced_search) {
                this.$router.replace({
                    query: {}
                });
            }
        },
        resetFilter() {
            let rQ = this.$route.query;
            this.Filter = "";
            if (rQ.search_query) {
                let {
                    search_query,
                    ...newQ
                } = rQ;
                this.$router.replace({
                    query: newQ
                });
            }
        },
        FilterData() {
            if (this.Filter) {
                let newQ = {
                    ...this.$route.query,
                    search_query: this.Filter
                };
                this.$router.replace({
                    query: newQ
                });
            }
        },
        goToPage(pageNo) {
            let newQ = {
                ...this.$route.query,
                pageNo
            };
            this.$router.replace({
                query: newQ
            });
        }
    },
    computed: {
        totalPages() {
            if (this.total === 0 || this.perPage === 0) {
                return 0;
            } else {
                return Math.ceil(this.total / this.perPage);
            }
        },
        pageNo: {
            get() {
                let pageNo = this.$route.query.pageNo || 1
                return parseInt(pageNo);
            },
            set() {
                true;
            }
        },
        pageStart() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.max(0, (this.pageNo - 1) * this.perPage + 1))
        },
        pageEnd() {
            if (this.total === 0) {
                return 0;
            }
            return (Math.min(this.total, this.pageNo * this.perPage))
        },
        FieldExecutiveList() {
            return this.$store.getters.FieldExecutiveMaster;
        },
        firmList() {
            let list = [];
            for (var i = 0; i < this.GetAllCpMeetings.length; i++) {
                list.push(this.GetAllCpMeetings[i].broker_name);
            }
            console.log(list);
            return list;
        },
    }
}
</script>
  
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
